import { Box, CircularProgress } from '@material-ui/core';
import React from 'react';

const CircularLoading = ({ height }: { height?: string }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: height ?? '300px',
        color: '#5CABDD',
      }}
    >
      <CircularProgress color="inherit" />
    </Box>
  );
};

export default CircularLoading;
